import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('userRouting', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('user-changePrimary', {
        parent: 'arw',
        url: '/change-primary-user/:retailerId/:primaryUserId',
        template: `<change-primary-user
                        model="appCtrl.appFactory.model"
                        api="$resolve.api"
                   ></change-primary-user>`,
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Change Primary User')));
            },
          ],
        },
        resolve: {
          api: [
            'appFactory',
            'appApi',
            (appFactory) =>
              appFactory
                .dispatch('user.loadDictionaries', true)
                .run()
                .then(() => ({
                  showAlert: appFactory.uiHelpers.showAlert,
                  config: appFactory.deps.config,
                  promoteToPrimary: appFactory.dispatch('user.promoteToPrimary', true),
                  nextPage: appFactory.dispatch('user.changePrimaryUser.nextPage', true),
                  prevPage: appFactory.dispatch('user.changePrimaryUser.prevPage', true),
                  gotoPage: appFactory.dispatch('user.changePrimaryUser.gotoPage', true),
                  applyFilters: appFactory.dispatch('user.changePrimaryUser.applyFilters', true),
                }))
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      })
      .state('user-createAccount', {
        parent: 'arw',
        url: '/create-account',
        template: '<create-account-steps></create-account-steps>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Create New User')));
            },
          ],
        },
      })
      .state('user-createSecondaryUserAccount', {
        parent: 'arw',
        url: '/create-secondary-user-account/:primaryUserId',
        template: '<create-account-steps></create-account-steps>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Create New User')));
            },
          ],
        },
      })
      .state('user-viewAccountDetails', {
        parent: 'arw',
        url: '/view-account-details/{id:[0-9]*}?tabId',
        template: `<edit-account-main
                        model="appCtrl.appFactory.model"
                        api="$resolve.api"
                   />`,
        params: {
          retailerId: null,
          skipDirtyForms: false,
        },
        redirectTo: 'permissions-denied',
        resolve: {
          api: [
            'appFactory',
            '$stateParams',
            'appApi',
            (appFactory, $stateParams) =>
              appFactory
                .dispatch('user.loadDictionaries', true)
                .run()
                .then(() => {
                  const { id, retailerId } = $stateParams;
                  return appFactory
                    .dispatch('user.loadDictionaries', true)
                    .run()
                    .then(() => appFactory.dispatch('user.loadUser', true).run(id, retailerId))
                    .then((model) => ({
                      config: appFactory.deps.config,
                      loadUser: appFactory.actions.user.loadUserById,
                      canEditAccountDetails: appFactory.deps.checkAccess(model, 'user.editAccountDetails'),
                      canEdit: appFactory.deps.checkAccess(model, 'user.canEdit'),
                      canCompleteRegistration: appFactory.deps.checkAccess(model, 'user.canCompleteRegistration'),
                      accountInactive: appFactory.deps.checkAccess(model, 'user.accountInactive'),
                      canResendActivationEmail: appFactory.deps.checkAccess(model, 'user.canResendActivationEmail'),
                      canAuthenticateUser: appFactory.deps.checkAccess(model, 'user.authenticateUser'),
                      isUserNotSuspended: appFactory.deps.checkAccess(model, 'user.isUserNotSuspended'),
                      canChangePrimaryUser: appFactory.deps.checkAccess(model, 'user.canChangePrimaryUser'),
                      canShowRetailerFields: appFactory.deps.checkAccess(model, 'user.canShowRetailerFields'),
                      canUpdateUserStatus: appFactory.checkValidators(model, 'user.canUpdateUserStatus'),
                      canUpdateAccountPrivileges:
                        appFactory.checkValidators(model, 'user.canUpdatePrivileges') && appFactory.deps.config.privilegesCustomization,
                      resendActivationEmail: appFactory.dispatch('user.canResendActivationEmail', true),
                      authenticateUser: appFactory.dispatch('user.authenticateUser', true),
                      activate: appFactory.dispatch('user.activate', true),
                      suspend: appFactory.dispatch('user.suspend', true),
                      updatePersonalData: appFactory.dispatch('user.updateSubordinateUser', true),
                      loginByRest: appFactory.dispatch('auth.loginByRest', true),
                      loadPrivileges: appFactory.dispatch('privilegeTemplates.loadPrivileges', true),
                      resetCurrentPreset: appFactory.dispatch('privilegeTemplates.resetCurrentPreset', true),
                      updateUserPrivileges: appFactory.dispatch('user.updateUserPrivileges', true),
                      showAlert: appFactory.uiHelpers.showAlert,
                      showComplexDialog: appFactory.uiHelpers.showComplexDialog,
                      redirectAfterLogin: appFactory.uiHelpers.redirectAfterLogin.bind(null, appFactory.deps),
                      deleteUser: appFactory.dispatch('user.deleteUser', true),
                    }));
                })
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      })
      .state('user-myAccount', {
        parent: 'arw',
        url: '/my-account',
        template: '<my-account></my-account>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('My Account')));
            },
          ],
        },
      })
      .state('user-manageUsers', {
        parent: 'arw',
        url: '/manage-users',
        template: `<manage-users
                        model="appCtrl.appFactory.model"
                        search-user="appCtrl.appFactory.deps.checkAccess(appCtrl.appFactory.model, 'user.manageUsersShowSearch')"
                        can-create-user="appCtrl.appFactory.deps.checkAccess(appCtrl.appFactory.model, 'user.createAccount')"
                        can-create-secondary="appCtrl.appFactory.deps.checkAccess(appCtrl.appFactory.model, 'user.createSecondaryUserAccount')"
                        api="$resolve.api"
                   ></manage-users>`,
        redirectTo: 'dashboard-summary',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Users')));
            },
          ],
        },
        resolve: {
          api: [
            'appFactory',
            'appApi',
            (appFactory) =>
              appFactory
                .dispatch('user.loadDictionaries', true)
                .run()
                .then(() => ({
                  config: appFactory.deps.config,
                  filterUsers: appFactory.dispatch('user.grid.applyFilters', true),
                  sortUsers: appFactory.dispatch('user.grid.sortByColumn', true),
                  prevPage: appFactory.dispatch('user.grid.prevPage', true),
                  nextPage: appFactory.dispatch('user.grid.nextPage', true),
                  gotoPage: appFactory.dispatch('user.grid.gotoPage', true),
                  exportReport: appFactory.actions.user.exportUserReport,
                }))
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      })
      .state('retailer-settings', {
        parent: 'arw',
        url: '/retailer-settings',
        template: '<retailer-settings></retailer-settings>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Retailer Settings')));
            },
          ],
        },
        withoutPerms: true,
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/user/user-routing-module.js